export default __webpack_public_path__ + "static/media/virgin-blue.0d6c72bd.png";